import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';

import { sendWsMessage } from '@/app/sagas/websocket';
import type { CurrencyCode } from '@/shared/lib/currency';
import { twa } from '@/shared/lib/telegram/twa';

import { balloonActions } from './slice';

function* startGameSaga(
  action: PayloadAction<{ betAmount: number; currency: CurrencyCode; giftId?: string }>,
): Generator {
  const sent = sendWsMessage({
    type: 'balloon_start',
    data: {
      betAmount: action.payload.betAmount,
      currency: action.payload.currency,
      giftId: action.payload.giftId,
    },
  });
  if (!sent) return; // WS not connected yet — don't set loading, user can retry immediately
  yield put(balloonActions.setLoading(true));
  twa.hapticFeedback.impactOccurred('medium');
}

// eslint-disable-next-line require-yield
function* heatStartSaga(): Generator {
  sendWsMessage({ type: 'balloon_heat_start' });
  twa.hapticFeedback.impactOccurred('medium');
}

// eslint-disable-next-line require-yield
function* heatStopSaga(): Generator {
  sendWsMessage({ type: 'balloon_heat_stop' });
  twa.hapticFeedback.impactOccurred('light');
}

// eslint-disable-next-line require-yield
function* takeSaga(): Generator {
  sendWsMessage({ type: 'balloon_take' });
  twa.hapticFeedback.notificationOccurred('success');
}

export function* balloonWatcher(): Generator {
  yield takeLatest(balloonActions.startGame.type, startGameSaga);
  yield takeLatest(balloonActions.heatStart.type, heatStartSaga);
  yield takeLatest(balloonActions.heatStop.type, heatStopSaga);
  yield takeLatest(balloonActions.take.type, takeSaga);
}
